<template>
  <div>
    <v-container>
      <v-row>
        <v-col sm="12" md="4" lg="4">
          <v-card>
            <v-card-title primary-title>
              <v-icon class="mr-2">mdi-account-box</v-icon>
              Jamaah
            </v-card-title>
            <div class="ml-6">
              <v-card class="mx-2 mr-10" elevation="0">
                <v-card-title>
                  Jumlah Kepala KK
                </v-card-title>
                <v-card-text>
                  <div class="display-1">
                    {{dataJamaah.sum_kk}}
                  </div>
                </v-card-text>
              </v-card>

              <v-card class="mx-2 mt-2" elevation="0">
                <v-card-title>
                  Jumlah Total Jamaah
                </v-card-title>
                <v-card-text>
                  <div class="display-1">
                    {{dataJamaah.total_jamaah}}
                  </div>
                </v-card-text>
              </v-card>

              <v-card class="mx-2 mt-2" elevation="0">
                <v-card-title>
                  Rata-rata Orang per Rumah
                </v-card-title>
                <v-card-text>
                  <div class="display-1">
                    {{dataJamaah.mean_kk}}
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <v-card-actions>
              <v-btn text to="/admin/jamaah/statistik">Lihat</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col sm="12" md="4" lg="4">
          <v-card>
            <v-card-title primary-title>
              <v-icon class="mr-2">mdi-cart</v-icon>
              Keuangan
            </v-card-title>
            <div class="ml-6">
              <v-card class="mx-2" elevation="0">
                <v-card-title>
                  Total Pemasukan
                </v-card-title>
                <v-card-text>
                  <div class="display-1">
                    Rp {{dataKeuangan.totalIncome.toLocaleString("id-ID")}}
                  </div>
                </v-card-text>
              </v-card>

              <v-card class="mx-2 mt-2" elevation="0">
                <v-card-title>
                  Total Pengeluaran
                </v-card-title>
                <v-card-text>
                  <div class="display-1">
                    Rp {{dataKeuangan.totalExpenses.toLocaleString("id-ID")}}
                  </div>
                </v-card-text>
              </v-card>

              <v-card class="mx-2 mt-2" elevation="0">
                <v-card-title>
                  Total Saldo
                </v-card-title>
                <v-card-text>
                  <div class="display-1">
                    Rp {{dataKeuangan.totalBalances.toLocaleString("id-ID")}}
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <v-card-actions>
              <v-btn text to="/admin/keuangan/statistik">Lihat</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-col sm="12" md="4" lg="4">
          <v-card>
            <v-card-title primary-title>
              <v-icon class="mr-2">mdi-calendar</v-icon>
              Kegiatan
            </v-card-title>
            <div class="ml-6">
              <v-card class="mx-2" elevation="0">
                <v-card-title>
                  Total Kegiatan
                </v-card-title>
                <v-card-text>
                  <div class="display-1">
                    {{dataKegiatan.length}}
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <v-card-actions>
              <v-btn text to="/admin/kegiatan/list">Lihat</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataJamaah: {},
      dataKegiatan: [],
      dataKeuangan: {
        totalIncome: 0,
        totalExpenses: 0,
        totalBalances: 0
      }
    };
  },
  created() {
    this.axios(`/jamaah/chart`)
    .then((response) => {
      this.dataJamaah = response.data;
    })
    .catch((error) => {
      console.log(error, 'error fetch data jamaah');
    });

    this.axios("/program/list")
      .then((response) => {
        // console.log(response.data.data);
        this.dataKegiatan = response.data.data;
      })
      .catch((error) => {
        console.log(error, 'error fetch data kegiatan');
      });

    this.axios("/keuangan/list")
    .then((res) => {
      // console.log(res.data.data, 'res fetch keuangan')
      res.data.data.map((el) => {
        if(el.transaction == "in") {
          this.dataKeuangan.totalIncome += Number(el.value)
        }else{
          this.dataKeuangan.totalExpenses += Number(el.value)
        }
      })

      this.dataKeuangan.totalBalances = this.dataKeuangan.totalIncome - this.dataKeuangan.totalExpenses
    })
    .catch((err) => {
      console.log(err, 'error fetch data keuangan')
    })
  }
};
</script>
